var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeuralNetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXl: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    viewBox: "739.7335 -921.7 34.399423 34.449707",
    width: 34.399423,
    height: 34.449707,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Produced by OmniGraffle 7.12.1 \n    ", /*#__PURE__*/React.createElement("dcDate", null, "2020-10-16 16:28:24 +0000"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    strokeDasharray: "none",
    fill: "none",
    stroke: "none",
    strokeOpacity: 1,
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Canvas 1"), /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1: Layer 1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Line_41"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 746.2063,
    y1: -911.151,
    x2: 754.1108,
    y2: -916.2102,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_40"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 746.5178,
    y1: -908.2813,
    x2: 753.7994,
    y2: -905.5968,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_39"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 745.3802,
    y1: -906.7792,
    x2: 754.937,
    y2: -893.6159,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_37"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 745.3328,
    y1: -901.4921,
    x2: 754.9843,
    y2: -915.3006,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_36"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 746.4629,
    y1: -900.0953,
    x2: 753.8543,
    y2: -903.2144,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_35"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 746.2721,
    y1: -897.1936,
    x2: 754.0451,
    y2: -892.6331,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_33"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 759.5836,
    y1: -916.227,
    x2: 767.6493,
    y2: -911.1341,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_32"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 758.7163,
    y1: -915.3125,
    x2: 768.5166,
    y2: -901.4802,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_31"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 759.8892,
    y1: -905.5835,
    x2: 767.3437,
    y2: -908.2947,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_30"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 759.8355,
    y1: -903.2289,
    x2: 767.3974,
    y2: -900.0808,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_29"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 758.7636,
    y1: -893.6035,
    x2: 768.4693,
    y2: -906.7916,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_28"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 759.6483,
    y1: -892.6165,
    x2: 767.5846,
    y2: -897.2102,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 756.84185,
    cy: -917.9582,
    r: 3.24184654604014,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 756.84185,
    cy: -904.4752,
    r: 3.24184654604013,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_23"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 756.84185,
    cy: -890.9921,
    r: 3.24184654604016,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_21"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 743.4753,
    cy: -909.403,
    r: 3.24184654604013,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 743.4753,
    cy: -898.8346,
    r: 3.24184654604019,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_19"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 770.39105,
    cy: -909.403,
    r: 3.2418465460401,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_18"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 770.39105,
    cy: -898.8346,
    r: 3.24184654604016,
    stroke: "#555874",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralNetIcon);
export default __webpack_public_path__ + "static/media/neural_net_icon.4260885d2fca64e44b6d3e47a63d10fe.svg";
export { ForwardRef as ReactComponent };